import DomHelper from "../../../utils/DomHelper";
import $ from 'jquery';

var clientSideSegments = {
    BFM: "data-clientside-segments-bfm",
    PRIVATE_BANKING: "data-clientside-segments-bp"
};

function SegmentControllerFactory(element, segmentName, segmentToHideName) {
    if (!element || !segmentName) return null;

    switch (segmentName) {
        case clientSideSegments.BFM:
            return new BfmSegmentController(element, clientSideSegments.BFM);
            break;
        case clientSideSegments.PRIVATE_BANKING:
            return new PrivateBankingSegmentController(
                element,
                clientSideSegments.PRIVATE_BANKING
            );
            break;
        default:
            return new SegmentController(element, segmentName, segmentToHideName);
            break;
    }
}

function SegmentController(element, segmentName, segmentToHideName) {
    if (!element || !segmentName) return null;

    this.element = element;
    this.segmentName = segmentName;
    this.segments = this._getSegments();

    if(typeof segmentToHideName !== "undefined"){
        this.segmentToHideName = segmentToHideName;
        this.segmentsToHide = this._getSegmentsToHide();
    }
}

SegmentController.prototype.setElement = function (element) {
    this.element = element;
};

SegmentController.prototype.setSegmentName = function (segmentName) {
    this.segmentName = segmentName;
};

SegmentController.prototype.removeElement = function () {
    $(this.element).remove();
};

SegmentController.prototype.showElement = function () {
    DomHelper.unwrap(this.element);
};

SegmentController.prototype.get = function () {
    return (!!this.segments && this.segments) || false;
};

SegmentController.prototype.getToHide = function () {
    return (!!this.segmentsToHide && this.segmentsToHide) || false;
};

SegmentController.prototype.isAnyActive = function () {
    if (!window.userSegments) {
        return false;
    }

    for (var i = 0; i < this.segments.length; i++) {
        if (window.userSegments.indexOf(this.segments[i]) >= 0) {
            return true;
        }
    }

    return false;
};

SegmentController.prototype._getSegments = function () {
    var segmentList = this._getSegmentListByName(this.segmentName);

    if(!segmentList){
        return null;
    }

    return this._getSegmentsFromListSeparatedBy(segmentList, ",");
};

SegmentController.prototype._getSegmentsToHide = function () {
    var segmentList = this._getSegmentListByName(this.segmentToHideName);

    if(!segmentList){
        return null;
    }

    return this._getSegmentsFromListSeparatedBy(segmentList, ",");
};

SegmentController.prototype._getSegmentListByName = function (name) {
    return this.element.getAttribute(name);
};

SegmentController.prototype._getSegmentsFromListSeparatedBy = function (segmentList, separator) {
    const indexOfEqual = segmentList.indexOf("=");
    const key = indexOfEqual >=0 ? segmentList.substring(0, indexOfEqual) + '=' : '';
    const values = segmentList.substring(indexOfEqual+1);

    return values.split(separator).map(singleValue => key + singleValue);
};

SegmentController.prototype.setAction = function (action) {
    this.element.setAttribute("action", action);
};

function BfmSegmentController(element, segmentName) {
    SegmentController.call(this, element, segmentName);
}

BfmSegmentController.prototype = Object.create(SegmentController.prototype);
BfmSegmentController.prototype.constructor = BfmSegmentController;

BfmSegmentController.prototype.setHeaderBrand = function () {
    this.element.classList.add("dcw_header--bfm");
};

function PrivateBankingSegmentController(element, segmentName) {
    SegmentController.call(this, element, segmentName);
}

PrivateBankingSegmentController.prototype = Object.create(
    SegmentController.prototype
);
PrivateBankingSegmentController.prototype.constructor = PrivateBankingSegmentController;

PrivateBankingSegmentController.prototype.setHeaderBrand = function () {
    this.element.classList.add("dcw_header--private");
};

export default SegmentControllerFactory;


// WEBPACK FOOTER //
// ./src/js/cms/commons/clientCustomizer/SegmentControllerFactory.js